const portal = {
	banner: [{
		tips:'我的申请',
		title:'我的申请',
		content:'',
		img: require('@/assets/img/index/GPI_2x.png'),
		url: require('@/assets/img/index/banner01.png'),
	}],	
	label:{
		corporate:'企业名称',
		type:'行业类型',
		company:'公司组织形式',
		phone:'手机号 / 邮箱',
		code:'验证码',
		submit_btn:'注册',
		get_code:'获取验证码',
	},
	placeholder:{
		corporate:'请输入企业名称',
		type:'请选择行业类型',
		company:'请选择公司组织形式',
		phone:'请输入手机号/邮箱',
		code:'请输入验证码',
	},
	rules:{
		corporate:	[{ required: true, message:'请输入企业名称', trigger: 'blur' },],
		type:	[{ required: true, message:'请选择行业类型', trigger: 'blur' },],	
		company:	[{ required: true, message:'请选择公司组织形式', trigger: 'blur' },],
		phone:	[{ required: true, message:'请输入手机号/邮箱', trigger: 'blur' },],
		code:	[{ required: true, message:'请输入验证码', trigger: 'blur' },]
	}
}

export default portal